import {useEffect, useState} from 'react'
import Loader from 'react-loader-spinner'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

import './index.css'

const BlogItemDetails = props => {
  const [blogItemData, setBlogItemData] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const getBlogData = async () => {
    const {match} = props
    const {params} = match
    const {id} = params
    const response = await fetch(`https://apis.ccbp.in/blogs/${id}`)
    const data = await response.json()
    const formattedData = {
      id: data.id,
      title: data.title,
      imageUrl: data.image_url,
      avatarUrl: data.avatar_url,
      author: data.author,
      content: data.content,
      topic: data.topic,
    }
    setBlogItemData(formattedData)
    setIsLoading(false)
  }

  useEffect(() => {
    getBlogData()
  })

  const renderBlogItemDetails = () => {
    const {title, imageUrl, content, avatarUrl, author} = blogItemData
    return (
      <div className="blog-info">
        <h2 className="blog-details-title">{title}</h2>

        <div className="author-details">
          <img className="author-pic" src={avatarUrl} alt={author} />
          <p className="details-author-name">{author}</p>
        </div>

        <img className="blog-image" src={imageUrl} alt={title} />
        <p className="blog-content">{content}</p>
      </div>
    )
  }

  return (
    <div className="blog-container">
      {isLoading ? (
        <Loader type="TailSpin" color="#00BFFF" height={50} width={50} />
      ) : (
        renderBlogItemDetails()
      )}
    </div>
  )
}

export default BlogItemDetails
